import React, { PropsWithChildren } from 'react';
import styled from 'styled-components';
import { Button } from '@blueprintjs/core';

import { AnchorButtonStyle, StyledNotFound404Header } from '../../templates/styles';
import { intl } from '../../../utils/Intl';
import pakEnergySmall from '../../../../assets/images/common/pak_energy_lockup.png';
export class ErrorBoundary extends React.Component<PropsWithChildren<any>, any> {
  constructor(props: any) {
    super(props);
    this.state = { isOpenError: false, error: '', errorInfo: '', hasError: false };
  }

  private handleClick = () => {
    this.setState({ isOpenError: !this.state.isOpenError });
  };

  static getDerivedStateFromError(error: any) {
    // Update state so the next render will show the fallback UI.
    return { error, hasError: true };
  }

  componentDidCatch(error: any, errorInfo: any) {
    // You can also log the error to an error reporting service
    console.log(error, errorInfo);
    this.setState({ errorInfo });
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return (
        <StyledErrorBoundary>
          <StyledNotFound404Header>
            <img src={pakEnergySmall} alt="" />
          </StyledNotFound404Header>
          <FlexAlignCenterStyled>
            <MainTextSWW>
              <span>{intl('app.errors.somethingWentWrong')}</span>
            </MainTextSWW>
          </FlexAlignCenterStyled>
          <FlexAlignCenterStyled>
            <TextSWW>{intl('app.errors.errorInLoadingThisPage')}</TextSWW>
          </FlexAlignCenterStyled>
          <FlexAlignCenterStyled>
            <AnchorButtonStyle
              icon="home"
              text={intl('app.reloadThisPage')}
              className="bp3-intent-warning bp3-large"
              onClick={() => window.location.reload()}
            />
          </FlexAlignCenterStyled>
          <FlexAlignCenterStyled>
            <details style={{ whiteSpace: 'pre-wrap', color: '#fff', cursor: 'pointer', marginTop: '1em' }}>
              <p>
                <strong>{intl('app.errors.theError')}:</strong> {this.state.error && this.state.error.toString()}
              </p>
            </details>
          </FlexAlignCenterStyled>
        </StyledErrorBoundary>
      );
    }

    return this.props.children;
  }
}

export const StyledErrorBoundary = styled.div`
  background-color: #396faa;
  width: 100%;
  height: 100vh;
  margin: 5px 0;
`;

export const FlexAlignCenterStyled = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const TextSWW = styled.span`
  color: #fff;
  text-transform: uppercase;
  margin-bottom: 1em;
`;

export const ButtonShowLog = styled(Button)`
  margin-top: 2em;
`;

export const MainTextSWW = styled(TextSWW)`
  font-size: 3em;
  font-weight: bold;
  margin-bottom: 0.5em;
`;
